const getNodes = (id) => {
    const wrapper = document.getElementById(id);
    if (!wrapper)
        return [];
    return Array.from(wrapper.getElementsByTagName('li')).map((el) => el.firstChild);
};
export default getNodes;
//# sourceMappingURL=getNodes.js.map